import { useEffect, useState } from "react";
import { RefreshCw } from "lucide-react";
import { getImportJobs, ImportJob } from "../../../Services/Admin/Venues";
import ImportPanel from "../VenuesPanel/ImportPanel";
import "./ImportsPanel.css";

export default function ImportsPanel() {
  const [jobs, setJobs] = useState<ImportJob[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const load = () => {
    setLoading(true);
    setError(null);
    getImportJobs()
      .then(setJobs)
      .catch((e) => setError(e?.message ?? "Could not load import jobs"))
      .finally(() => setLoading(false));
  };

  useEffect(load, []);

  return (
    <div className="imports-admin-grid">
      <section className="admin-surface">
        <div className="admin-section-heading">
          <div><span className="admin-eyebrow">OpenStreetMap</span><h2>Import venues</h2></div>
        </div>
        <ImportPanel onFinished={load} />
      </section>

      <section className="admin-surface">
        <div className="admin-section-heading">
          <div><span className="admin-eyebrow">Latest 10 jobs</span><h2>Import history</h2></div>
          <button className="admin-icon-button" type="button" onClick={load} disabled={loading} aria-label="Refresh import jobs">
            <RefreshCw size={16} className={loading ? "is-spinning" : ""} />
          </button>
        </div>
        {error && <div className="admin-error">{error}</div>}
        {!loading && jobs.length === 0 ? (
          <p className="admin-empty">No venue imports have run yet. Choose a city above to start one.</p>
        ) : (
          <div className="import-history-table-wrap">
            <table className="admin-table">
              <thead><tr><th>Status</th><th>Started</th><th>Progress</th><th>Result</th><th>Message</th></tr></thead>
              <tbody>
                {jobs.map((job) => {
                  const processed = job.created + job.updated + job.skipped;
                  return (
                    <tr key={job.id}>
                      <td><span className={`admin-status admin-status--${job.status}`}>{job.status}</span></td>
                      <td>{new Date(job.startedAt ?? job.createdAt).toLocaleString()}</td>
                      <td>{job.total ? `${processed} / ${job.total}` : "—"}</td>
                      <td>{job.created} new · {job.updated} updated · {job.skipped} skipped</td>
                      <td className={job.status === "failed" ? "import-history-error" : ""}>{job.message ?? "—"}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </section>
    </div>
  );
}
